.box {
    border-radius: 8px;
    padding: 1rem;
}

.animation {
    animation: fade-in 1s;
}

.darkBlue {
    background-color: var(--ax-brand-blue-200);
}

.blue {
    background-color: var(--ax-brand-blue-100);
}

@keyframes fade-in {
    from {
        opacity: 0;
    }
    to {
        opacity: 100;
    }
}
